<template>
  <div>
    <el-button v-show="row.status != 2" size="mini" type="primary" @click="deliverTask">{{
      text
    }}</el-button>
    <span v-show="row.status == 2">-</span>
  </div>
</template>
<script>
// import { getCommonAjax } from "@/api/common"
import sendMsg from "@/views/maintenanceManage/sendMsg";
export default {
  props: {
    cusprop: {},
    row: {},
  },
  computed: {
    text() {
      return this.row.status == 1 ? "再次下发" : "下发任务";
    },
  },
  methods: {
    deliverTask() {
      this.$dialog.open({
        title: "下发任务",
        theme: "feature-dialog",
        shade: true,
        area: {
          height: "200px",
          width: "380px",
        },
        location: {
          top: "100px",
        },
        content: {
          type: "vue",
          subCom: sendMsg,
          subData: JSON.parse(JSON.stringify(this.row)),
        },
      });
      // getCommonAjax('/wxrw/sendRw', {
      //     rwCode: this.row.rwCode,
      //     cardNumber: this.row.cardNumber,
      // }).then(res => {
      //     this.$message({
      //         message: "任务下发成功",
      //         type: "success",
      //     });
      //     this.$bus.$emit("task-list");
      // }).catch(err => {
      //     console.error(err);
      // });
    },
  },
};
</script>
